export default __webpack_public_path__ + "static/media/map-location.8e7865de.png";